import axios from 'axios';
import { apiServerHost } from '../../../common/APIServerSettings';

const deleteEntity = (callBackFunc, entityUpdateID) => {
  const params = new URLSearchParams();
  params.append('entityID', entityUpdateID);

  axios.post(apiServerHost + "/manage/topic/builder/delete/entity", params)
  .catch( error => {
    
  })
  .then( response => {
    callBackFunc(response);
  })
}

export {deleteEntity};